const ErrorPage = () => {
  return <>404 not found</>
}

export default ErrorPage
